
import { getPlatformFeaturedProviders, getPlatformProvider } from '@/services/platformApi/publicCatalogApi';
import { Provider, ServiceProviderRow } from "@/types/supabase";
import { debugLogger } from '@/utils/debug';

/**
 * Get featured service providers
 * @param limit Maximum number of providers to return
 * @returns Array of providers
 */
export async function getFeaturedProviders(limit: number = 6): Promise<Provider[]> {
  return getPlatformFeaturedProviders(limit);
}

/**
 * Get provider by ID
 * @param id Provider ID
 * @returns Provider object or null if not found
 */
export async function getProviderById(id: string): Promise<Provider | null> {
  try {
    return getPlatformProvider(id);
  } catch (error) {
    console.error("Error in getProviderById:", error);
    return null;
  }
}

/**
 * Get service provider by ID
 * @param id Service provider ID
 * @returns Service provider data or null if not found
 */
export const getServiceProviderById = async (id: string): Promise<ServiceProviderRow | null> => {
  try {
    debugLogger.log("Getting service provider by ID:", id);
    return await getPlatformProvider(id, { includeUnapproved: true }) as ServiceProviderRow | null;
  } catch (error) {
    console.error("Unexpected error in getServiceProviderById:", error);
    return null;
  }
};
